import { render, staticRenderFns } from "./BidRequestSubHireDetail.vue?vue&type=template&id=8664ef1a"
import script from "./BidRequestSubHireDetail.vue?vue&type=script&lang=js"
export * from "./BidRequestSubHireDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports